"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentResponseStatusMessage = void 0;
const getPaymentResponseStatusMessage = (code) => {
    switch (code) {
        case "0000":
            return "Successful";
        case "0001":
            return "Transaction is pending";
        case "0003":
            return "Transaction is cancelled";
        case "0999":
            return "System error";
        case "2001":
            return "Transaction in progress";
        case "2002":
            return "Transaction not found";
        case "2003":
            return "Failed To Inquiry";
        case "4001":
            return "Refer to card issuer";
        case "4002":
            return "Refer to issuer's special conditions";
        case "4003":
            return "Invalid merchant ID";
        case "4004":
            return "Pick up card";
        case "4005":
            return "Do not honor";
        case "4006":
            return "Error";
        case "4007":
            return "Pick up card, special condition";
        case "4008":
            return "Honor with ID";
        case "4009":
            return "Request in progress";
        case "4010":
            return "Partial amount approved";
        case "4011":
            return "Approved VIP";
        case "4012":
            return "Invalid Transaction";
        case "4013":
            return "Invalid Amount";
        case "4014":
            return "Invalid Card Number";
        case "4015":
            return "No such issuer";
        case "4016":
            return "Approved, Update Track 3";
        case "4017":
            return "Customer Cancellation";
        case "4018":
            return "Customer Dispute";
        case "4019":
            return "Re-enter Transaction";
        case "4020":
            return "Invalid Response";
        case "4021":
            return "No Action Taken";
        case "4022":
            return "Suspected Malfunction";
        case "4023":
            return "Unacceptable Transaction Fee";
        case "4024":
            return "File Update Not Supported by Receiver";
        case "4025":
            return "Unable to Locate Record on File";
        case "4026":
            return "Duplicate File Update Record";
        case "4027":
            return "File Update Field Edit Error";
        case "4028":
            return "File Update File Locked Out";
        case "4029":
            return "File Update not Successful";
        case "4030":
            return "Format Error";
        case "4031":
            return "Bank Not Supported by Switch";
        case "4032":
            return "Completed Partially";
        case "4033":
            return "Expired Card - Pick Up";
        case "4034":
            return "Suspected Fraud - Pick Up";
        case "4035":
            return "Restricted Card - Pick Up";
        case "4036":
            return "Allowable PIN Tries Exceeded";
        case "4037":
            return "No Credit Account";
        case "4038":
            return "Allowable PIN Tries Exceeded";
        case "4039":
            return "No Credit Account";
        case "4040":
            return "Requested Function not Supported";
        case "4041":
            return "Lost Card - Pick Up";
        case "4042":
            return "No Universal Amount";
        case "4043":
            return "Stolen Card - Pick Up";
        case "4044":
            return "No Investment Account";
        case "4045":
            return "Settlement Success";
        case "4046":
            return "Settlement Fail";
        case "4047":
            return "Cancel Success";
        case "4048":
            return "Cancel Fail";
        case "4049":
            return "No Transaction Reference Number";
        case "4050":
            return "Host Down";
        case "4051":
            return "Insufficient Funds";
        case "4052":
            return "No Cheque Account";
        case "4053":
            return "No Savings Account";
        case "4054":
            return "Expired Card";
        case "4055":
            return "Incorrect PIN";
        case "4056":
            return "No Card Record";
        case "4057":
            return "Transaction Not Permitted to Cardholder";
        case "4058":
            return "Transaction Not Permitted to Terminal";
        case "4059":
            return "Suspected Fraud";
        case "4060":
            return "Card Acceptor Contact Acquirer";
        case "4061":
            return "Exceeds Withdrawal Amount Limits";
        case "4062":
            return "Restricted Card";
        case "4063":
            return "Security Violation";
        case "4064":
            return "Original Amount Incorrect";
        case "4065":
            return "Exceeds Withdrawal Frequency Limit";
        case "4066":
            return "Card Acceptor Call Acquirer Security";
        case "4067":
            return "Hard Capture - Pick Up Card at ATM";
        case "4068":
            return "Response Received Too Late";
        case "4069":
            return "Reserved";
        case "4070":
            return "Settle amount cannot exceed authorized amount";
        case "4071":
            return "Inquiry Record Not Exist";
        case "4072":
            return "Promotion not allowed in current payment method";
        case "4073":
            return "Promotion Limit Reached";
        case "4074":
            return "Reserved";
        case "4075":
            return "Allowable PIN Tries Exceeded";
        case "4076":
            return "Invalid Credit Card Format";
        case "4077":
            return "Invalid Expiry Date Format";
        case "4078":
            return "Invalid Three Digits Format";
        case "4079":
            return "Reserved";
        case "4080":
            return "User Cancellation by Closing Internet Browser";
        case "4081":
            return "Unable to Authenticate Card Holder";
        case "4082":
            return "Reserved";
        case "4083":
            return "Reserved";
        case "4084":
            return "Reserved";
        case "4085":
            return "Reserved";
        case "4086":
            return "ATM Malfunction";
        case "4087":
            return "No Envelope Inserted";
        case "4088":
            return "Unable to Dispense";
        case "4089":
            return "Administration Error";
        case "4090":
            return "Cut-off in Progress";
        case "4091":
            return "Issuer or Switch is Inoperative";
        case "4092":
            return "Financial Institution Not Found";
        case "4093":
            return "Trans Cannot Be Completed";
        case "4094":
            return "Duplicate Transmission";
        case "4095":
            return "Reconcile Error";
        case "4096":
            return "System Malfunction";
        case "4097":
            return "Reconciliation Totals Reset";
        case "4098":
            return "MAC Error";
        case "4099":
            return "Unable to Complete Payment";
        case "4110":
            return "Settled";
        case "4120":
            return "Refunded";
        case "4121":
            return "Refund Rejected";
        case "4122":
            return "Refund Failed";
        case "4130":
            return "Chargeback";
        case "4131":
            return "Chargeback Rejected";
        case "4132":
            return "Chargeback Failed";
        case "4140":
            return "Transaction Does Not Exist";
        case "4200":
            return "Tokenization Successful";
        case "4201":
            return "Tokenization Failed";
        case "4202":
            return "Invalid cardToken";
        case "5002":
            return "Timeout";
        case "5003":
            return "Invalid Message";
        case "5004":
            return "Invalid Profile (Merchant) ID";
        case "5005":
            return "Duplicated Invoice";
        case "5006":
            return "Invalid Amount";
        case "5007":
            return "Insufficient Balance";
        case "5008":
            return "Invalid Currency Code";
        case "5009":
            return "Payment Expired";
        case "5010":
            return "Payment Canceled By Payer";
        case "5011":
            return "Invalid Payee ID";
        case "5012":
            return "Invalid Customer ID";
        case "5013":
            return "Account Does Not Exist";
        case "5014":
            return "Authentication Failed";
        case "5015":
            return "Customer paid more than transaction amount";
        case "5016":
            return "Customer paid less than transaction amount";
        case "5017":
            return "Paid Expired";
        case "5018":
            return "Reserved";
        case "5019":
            return "No-Action From WebPay";
        case "5998":
            return "Internal Error";
        case "6012":
            return "Invalid Transaction";
        case "6101":
            return "Invalid request message";
        case "6102":
            return "Required Payload";
        case "6103":
            return "Invalid JWT data";
        case "6104":
            return "Required merchantId";
        case "6105":
            return "Required paymentChannel";
        case "6106":
            return "Required authCode";
        case "6107":
            return "Invalid merchantId";
        case "6108":
            return "Invalid paymentChannel";
        case "6109":
            return "paymentChannel is not configured";
        case "6110":
            return "Unable to retrieve usertoken";
        case "7012":
            return "Invalid Transaction";
        case "9004":
            return "The value is not valid";
        case "9005":
            return "Some mandatory fields are missing";
        case "9006":
            return "This field exceeded its authorized length";
        case "9007":
            return "Invalid merchant";
        case "9008":
            return "Invalid payment expiry";
        case "9009":
            return "Amount is invalid";
        case "9010":
            return "Invalid Currency Code";
        case "9012":
            return "paymentItem name is required";
        case "9013":
            return "paymentItem quantity is required";
        case "9014":
            return "paymentItem amount is required";
        case "9015":
            return "Existing Invoice Number";
        case "9016":
            return "Failed to retrieve PaymentInstruction";
        case "9017":
            return "PaymentInstruction not available";
        case "9035":
            return "Payment failed";
        case "9037":
            return "Merchant configuration is missing";
        case "9038":
            return "Failed To Generate Token";
        case "9039":
            return "The merchant frontend URL is missing";
        case "9040":
            return "The token is invalid";
        case "9041":
            return "Payment token already used";
        case "9042":
            return "Hash value mismatch";
        case "9057":
            return "Payment options are invalid";
        case "9058":
            return "Payment channel invalid";
        case "9059":
            return "Payment channel unauthorized";
        case "9060":
            return "Payment channel unconfigured";
        case "9078":
            return "Promotion code does not exist";
        case "9080":
            return "Tokenization not allowed";
        case "9088":
            return "SubMerchant is required";
        case "9089":
            return "Duplicated SubMerchant";
        case "9090":
            return "SubMerchant Not Found";
        case "9091":
            return "Invalid Sub Merchant ID";
        case "9092":
            return "Invalid Sub Merchant invoiceNo";
        case "9093":
            return "Existing Sub Merchant Invoice Number";
        case "9094":
            return "Invalid Sub Merchant Amount";
        case "9095":
            return "Sub Merchant Amount mismatch";
        case "9100":
            return "FxRateId and OriginalAmount are required";
        case "9101":
            return "Not allow to make a payment with Fx";
        case "9102":
            return "FxRate not available";
        case "9103":
            return "Invalid amount. (for the transaction which using the FxRateId)";
        case "9104":
            return "Invalid Country Code (Airline Info)";
        case "9105":
            return "Invalid Currency Code (Airline Info)";
        case "9106":
            return "Invalid Loyalty Redeem Amount";
        case "9107":
            return "Invalid Loyalty Provider";
        case "9108":
            return "Duplicated Loyalty Reward Id";
        case "9109":
            return "Required Loyalty's External Merchant Id";
        case "9110":
            return "Failed to Inquiry Loyalty Rewards";
        case "9202":
            return "Invalid cardToken";
        case "9900":
            return "Unable to decrypt the payload";
        case "9901":
            return "Invalid invoicePrefix";
        case "9902":
            return "allowAccumulate is required";
        case "9903":
            return "maxAccumulateAmount is required";
        case "9904":
            return "recurringInterval or ChargeOnDate is required";
        case "9905":
            return "recurringCount is required";
        case "9906":
            return "recurringInterval or ChargeOnDate is required";
        case "9907":
            return "Invalid ChargeNextDate";
        case "9908":
            return "Invalid ChargeOnDate";
        case "9909":
            return "chargeNextDate is required";
        case "9990":
            return "Request to merchant front end has failed";
        case "9991":
            return "Request merchant secure has failed";
        case "9992":
            return "Request payment secure has failed";
        case "9993":
            return "An unknown error has occurred";
        case "9994":
            return "Request DB service has failed";
        case "9995":
            return "Request payment service has failed";
        case "9996":
            return "Request Qwik service has failed";
        case "9997":
            return "Request user preferences has failed";
        case "9998":
            return "Request store card has failed";
        case "9999":
            return "Request to merchant backend has failed";
        default:
            return "Unknown status code";
    }
};
exports.getPaymentResponseStatusMessage = getPaymentResponseStatusMessage;
